// src/lib/ThemeContext.js
import React, { createContext, useContext, useState } from 'react';
import { getSavedTheme, saveTheme, getTheme } from './theme';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [themeKey, setThemeKey] = useState(getSavedTheme);
  const theme = getTheme(themeKey);

  const switchTheme = (key) => {
    saveTheme(key);
    setThemeKey(key);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeKey, switchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
